import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { Phone } from '@mui/icons-material';

const CopyrightKFGWA = (props) => {
  return (
    <Container component="main" maxWidth="false" sx={{ p: 2, bgcolor: "#F0F0F0", '@media (max-width: 479.95px)': { p: 1 } }}>
      <Box
        sx={{
          // marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Grid container maxWidth="lg">
          <Grid item xs={12} sm={2} display="flex" justifyContent={"center"} alignItems="center">
            <a href="http://www.flatglass.or.kr" target="_blank" rel="noreferrer">
              <img src="/kfgwa_footer_logo.png"/>
            </a>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ color: '#878787' }}>
            <Typography sx={{ fontSize: '14px', '@media (max-width: 479.95px)': { fontSize: '12px' } }}>
              {"(사)한국판유리창호협회, (T) 02-3453-7991, (F) 02-3453-0550"}
            </Typography>
            <Typography sx={{ fontSize: '14px', '@media (max-width: 479.95px)': { fontSize: '12px' } }}>
              {"본사 : 서울시 마포구 서강로 136, 아이비타워 8층 (노고산동)"}
            </Typography>
            <Typography sx={{ fontSize: '14px', '@media (max-width: 479.95px)': { fontSize: '12px' } }}>
              {"copyright© "}{new Date().getFullYear()}{" KFGWA, All RIGHT RESERVED"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent={"center"} alignItems="center" sx={{ color: '#878787' }}>
            <Grid container>
              <Grid item xs={12} sm={9}>
                <span style={{ fontSize: '16px' }}>{"대표전화 | "}&nbsp;</span><span style={{ fontSize: '14px' }}>{"CUSTOMER CENTER"}</span>
                <Typography sx={{ fontSize: '30px', '@media (max-width: 479.95px)': { fontSize: '22px' } }}>
                  <Phone sx={{ verticalAlign: 'middle', mr: 1 }} />
                  {"02-3453-7991"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

export default CopyrightKFGWA;